import { LookupType } from "./lookups";

export const DONOTREPEAT = 0;
export const WEEKLY = 1;
export const FORTNIGHTLY = 5;
export const MONTHLY = 2;
export const QUARTERLY = 3;
export const BIANNUALLY = 4;

export const RegularWithdrawalsLookup: Array<LookupType> = [
    { value: DONOTREPEAT, key: "Do not repeat" },
    { value: WEEKLY, key: "Every week" },
    { value: FORTNIGHTLY, key: "Every fortnight" },
    { value: MONTHLY, key: "Every month" },
    { value: QUARTERLY, key: "Every quarter" },
    { value: BIANNUALLY, key: "Biannually" }
];